"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIEWED_ORDER_IDS_STORAGE = exports.REDIRECT_ROUTE = exports.NEW_CHANNEL_LOCAL_STORAGE = exports.HERO_CONNECT_USER_LOCAL_STORAGE = exports.USER_LOCAL_STORAGE = void 0;
exports.USER_LOCAL_STORAGE = "user_local_storage";
exports.HERO_CONNECT_USER_LOCAL_STORAGE = "hero_connect_user_local_storage";
exports.NEW_CHANNEL_LOCAL_STORAGE = "new_channel_local_storage";
exports.REDIRECT_ROUTE = "redirect_route";
exports.VIEWED_ORDER_IDS_STORAGE = "viewed_order_ids_storage";
